import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import { MdPayments } from 'react-icons/md';
import { formatCurrency } from 'utils/formatters';
import { PAYMENT_STATUS_COLORS } from 'constants';

const PaymentSummaryCell = ({
  totalValue = 0,
  totalPaid = 0,
  paymentCount = 0,
  hasOverdue = false,
  nextPaymentStatus = null,
  nextPaymentEffectiveStatus = null,
}) => {
  const progress = totalValue > 0 ? (totalPaid / totalValue) * 100 : 0;
  const remaining = Math.max(totalValue - totalPaid, 0);

  // Use effective_status if available for progress bar color
  const displayStatus = nextPaymentEffectiveStatus || nextPaymentStatus;
  const displayColor = displayStatus ? (PAYMENT_STATUS_COLORS[displayStatus] || '#808080') : null;

  // Progress bar color: Use payment status color if available, otherwise use progress-based colors
  const progressColor = displayColor || (
    progress >= 100 ? '#16a34a' : progress > 0 ? '#f59e0b' : '#2563eb'
  );

  return (
    <Box width="100%">
      <Box display="flex" justifyContent="flex-start" alignItems="center" mb={0.5}>
        <Typography variant="caption">{progress.toFixed(1)}%</Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={Math.min(progress, 100)}
        sx={{
          height: 6,
          borderRadius: 1,
          backgroundColor: '#e5e7eb',
          '& .MuiLinearProgress-bar': { backgroundColor: progressColor },
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={0.5}>
        <Typography variant="caption" color="text.secondary">
          {formatCurrency(totalPaid, 'USD')} / {formatCurrency(totalValue, 'USD')}
        </Typography>
        <Tooltip title={`${paymentCount} payments`}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <MdPayments size={14} />
            <Typography variant="caption">{paymentCount}</Typography>
          </Box>
        </Tooltip>
      </Box>
      {!!remaining && (
        <Typography variant="caption" color="warning.main">
          Remaining {formatCurrency(remaining, 'USD')}
        </Typography>
      )}
    </Box>
  );
};

export default PaymentSummaryCell;


